 import { Component, OnInit, Input } from '@angular/core';
import { FramesEntity } from 'src/app/models/frames-entity.model';

@Component({
  selector: 'no-sidebar-layout',
  templateUrl: './no-sidebar-layout.component.html',
  styleUrls: ['./no-sidebar-layout.component.scss']
})
export class NoSidebarLayoutComponent implements OnInit {

  @Input() nav?: FramesEntity;
  @Input() header?: FramesEntity;
  @Input() main?: FramesEntity;
  @Input() footer?: FramesEntity;

  constructor(){ }

  ngOnInit(): void {

  }

}
